import {
  Building2, Bus, Car, CircleHelp, Compass, Globe, LayoutGrid, Link2, Mail, MapPin,
  MessageCircle, Phone, Plane, Snowflake, Sun, Zap,
} from 'lucide-react';

// The website header's own icons, for every place the dashboard leaves on Automatic. They
// mirror sunsky-website src/Layout/Navbar/Navbar.jsx, so the editor and the live preview show
// what a visitor will actually see.

export const SUPPORT_ICON_OPTIONS = [
  { value: 'phone', label: 'Phone', icon: Phone },
  { value: 'help', label: 'Help', icon: CircleHelp },
  { value: 'chat', label: 'Chat', icon: MessageCircle },
  { value: 'mail', label: 'Mail', icon: Mail },
];

export const supportIcon = (name) =>
  (SUPPORT_ICON_OPTIONS.find((o) => o.value === name) || SUPPORT_ICON_OPTIONS[0]).icon;

// The phone menu's built-in rows.
export const SERVICE_ICONS = {
  holidays: Sun,
  flights: Plane,
  hotels: Building2,
  transfers: Bus,
};

export const SERVICE_NAMES = {
  holidays: 'Holidays',
  flights: 'Flights',
  hotels: 'Hotels',
  transfers: 'Transfers',
};

// Holiday type rows: the website picks its icon from the type's name.
export const holidayTypeIcon = (name) => {
  const n = String(name || '').toLowerCase();
  if (n.includes('ski') || n.includes('snow') || n.includes('winter')) return Snowflake;
  if (n.includes('sun') || n.includes('beach')) return Sun;
  if (n.includes('city')) return Building2;
  if (n.includes('car') || n.includes('road')) return Car;
  if (n.includes('last minute') || n.includes('deal')) return Zap;
  return Compass;
};

// The button beside each menu's label, and a row's icon when none is picked.
export const MENU_BUTTON_ICONS = {
  destinations: Globe,
  holidayTypes: Sun,
  custom: LayoutGrid,
};

export const DESTINATION_ROW_ICON = MapPin;
export const CUSTOM_ROW_ICON = Link2;
